<div
  class="left navside dark dk channels"
  layout="column"
  [class.lowered]="failedPayment"
  [class.blurred]="blurred"
>
  <cc-channels-left-menu></cc-channels-left-menu>
</div>
